import React from "react";
import {
  ModalLayout,
  MultiColumnTable,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import useDeclarationDetail from "./useDeclarationDetail";
import OverviewShimmer from "../../../Global/Shimmers/OverviewShimmer";
import EmptyData from "../../../Global/EmptyData";
import { ImageCard } from "../../../Global/ImageCard";

const DeclarationDetail = () => {
  const {
    topLevelData,
    priorRemittances,
    priorRemittanceFields,
    esign,
    esignData,
    showPdfModal,
    downloadLoading,
    setShowPdfModal,
    handleDownloadPdf,
    isFetching,
  } = useDeclarationDetail();

  const getRow = (field, data) => {
    return <p className="pro-mb-0">{data[field]}</p>;
  };

  return (
    <div>
      {isFetching ? (
        <div className="pro-p-4 pro-w-100">
          <OverviewShimmer />
        </div>
      ) : (
        <div className="pro-py-5">
          {topLevelData.length === 0 &&
          !esign &&
          priorRemittances.length === 0 ? (
            <EmptyData />
          ) : (
            <>
              {topLevelData.length > 0 && (
                <div className="pro-mb-4">
                  <MultiColumnTable
                    minWidth={`30%`}
                    title={"Declaration Details"}
                    data={topLevelData}
                  />
                </div>
              )}

              {esign && (
                <div className="pro-mb-4">
                  <MultiColumnTable
                    minWidth={`30%`}
                    title={"E-Sign"}
                    data={esignData}
                  />
                </div>
              )}

              {priorRemittances.length > 0 && (
                <div className="pro-pt-4">
                  <h6 className="pro-ttl h6 pro-mb-4 pro-fw-bold">
                    Prior Remittances
                  </h6>
                  <Table
                    data={priorRemittances}
                    uniqueID={"date"}
                    showCheckBox={false}
                    deletable={false}
                    assignable={false}
                    multiSelect={false}
                    fields={priorRemittanceFields}
                    getRow={getRow}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}

      <ModalLayout
        show={showPdfModal}
        handleClose={() => setShowPdfModal(false)}
        backdrop="static"
      >
        <ImageCard
          data={esign?.signed_document_url}
          documentType="pdf"
          handleClose={() => setShowPdfModal(false)}
          handleDownloadPdf={handleDownloadPdf}
          downloadLoading={downloadLoading}
          status={-1}
          statusObj={{}}
          itemRejected={false}
          setItemRejected={() => {}}
          note=""
          setNote={() => {}}
          rejectReason={null}
        />
      </ModalLayout>
    </div>
  );
};

export default DeclarationDetail;
